<!-- Ensembl Rapid Release table-->
<div [hidden]="!dataSource.data || dataSource.data.length == 0">
  <h3 style="margin-bottom: 20px;">
    Ensembl Rapid Release
    @if (parentComponent === 'eurofaangMainPage') {
      <span class="projectNamesTitle">
        associated with {{projectArr.join(', ')}}
      </span>
    }
  </h3>

  <table mat-table matSort matSortDisableClear [dataSource]="dataSource" style="width: 100%; margin-top: 15px;">
    @for (tableDef of tableDefinitions; track tableDef) {
      <ng-container [matColumnDef]="tableDef['columnDefinition']">
        @if (tableDef.hasOwnProperty('span')) {
          <th mat-header-cell *matHeaderCellDef class="table-header"> {{tableDef['columnTitle']}} </th>
          <td mat-cell *matCellDef="let element" class="table-cell-data">
            @for (i of element[tableDef['cellVar']]; track i; let isLast = $last) {
              @if (tableDef['span'] && tableDef['span']['href']) {
                <a [href]="i[tableDef['span']['href']]">{{i[tableDef['span']['linkText']]}}</a>
                @if (!isLast) {
                  <span>, </span>
                }
              }
            }
          </td>
        } @else {
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header"> {{tableDef['columnTitle']}} </th>
          <td mat-cell *matCellDef="let element" class="table-cell-data"> {{element[tableDef['cellVar']]}} </td>
        }
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator pageSize="10" [length]="totalHits"></mat-paginator>
</div>
